import { createSlice } from '@reduxjs/toolkit';
const initialState = { viewerMode: false };
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setViewerMode(state, action) {
            state.viewerMode = action.payload;
        }
    }
});
export const { setViewerMode } = authSlice.actions;
export default authSlice.reducer;
